export const calculateLimitPosition = (setWidth, component) => {
  const element = document.getElementsByClassName(component)[0];
  const width = element ? element.offsetWidth : 0;
  setWidth({ width, visible: true });
};
